import { configureStore } from '@reduxjs/toolkit';
import { baseApi } from './baseApi';
import './categoryApi';
import './subcategoryApi';
import './productApi';
import './outletApi';
import './bannerApi';
import './announcementApi';
import './noticeBoardApi';
import './emailHistoryApi';
import './licenceApi';
import './vendorApi';
import './behaviourApi';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

